import {
  createKeyvalStorage,
  createKeyvalView,
} from '$logic/lib/keyval.storage'

interface NotifAudio {
  muted: boolean
}

const key = 'notif-audio'

export const notifAudioStorage = createKeyvalStorage<NotifAudio>(key)

export const notifAudioView = createKeyvalView<NotifAudio>(key)
